import styled from 'styled-components'

const Container = styled.div`
  max-width: 112px;
  width: 112px;
  svg.logo__mobile {
    display: block;
  }

  svg.logo__desktop {
    display: none;
  }

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {    
    svg.logo__mobile {
    display: none;
  }

  svg.logo__desktop {
    display: block;
  }
  }
`

export { Container }
